import { render, staticRenderFns } from "./PersonalDetails.vue?vue&type=template&id=f98154ae&scoped=true"
import script from "./PersonalDetails.vue?vue&type=script&lang=js"
export * from "./PersonalDetails.vue?vue&type=script&lang=js"
import style0 from "./PersonalDetails.vue?vue&type=style&index=0&id=f98154ae&prod&scoped=true&lang=css"
import style1 from "./PersonalDetails.vue?vue&type=style&index=1&id=f98154ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98154ae",
  null
  
)

export default component.exports